import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo } from '../../hooks/useSeo';
import { NOINDEX_TITLES, SITE_NAME } from '../../seo/site';

export const RouteSeo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const key = Object.keys(NOINDEX_TITLES).find((p) => pathname === p || pathname.startsWith(`${p}/`));
    if (key) {
      applySeo({ title: `${NOINDEX_TITLES[key]} | ${SITE_NAME}`, description: 'Interner Bereich von gastro-beratung.de.', path: pathname, noindex: true });
    }
  }, [pathname]);
  return null;
};
